import { render, staticRenderFns } from "./HistorialServiciosConexion.vue?vue&type=template&id=b5e33b6a&"
import script from "./HistorialServiciosConexion.vue?vue&type=script&lang=js&"
export * from "./HistorialServiciosConexion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports